import { trustedRequest, putRequest } from 'utils/request';

export const getSelectedNotifications = () => trustedRequest(`/api/notifications`);
export const updateNotifications = putRequest('/api/notifications');